import BaseModelAPI from '../BaseModelAPI';

export default class Vendor extends BaseModelAPI {
	static entity = 'vendor';
	static entityName = 'vendor';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.code = '';
		this.name = '';
		this.officeAddress = '';
		this.officePhoneNumber = '';
		this.contactPerson = '';
		this.contactPersonPhoneNumber = '';
		this.contactPersonEmail = '';
		this.vendorTypeId = '';
		this.vendorType = {};
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

	static async getByPurchaseRequisition(this_, id, filter, sorting, pageIndex, pageSize) {
		let filterArray = Array();
		if (filter != null && filter != undefined) {
			filterArray = this.getFilter(filter);
		}
		if (sorting != null && sorting != undefined) {
			Object.entries(sorting).map(([key, value]) => { if (value != '') filterArray.push("sorting[" + key + "]=" + (value ? "1" : "0")); });
		}
		if (pageIndex != null) {
			filterArray.push("pageIndex=" + pageIndex);
		}
		if (pageSize != null) {
			filterArray.push("pageSize=" + pageSize);
		}
		let params = "";
		if (filterArray.length > 0) {
			params = "?" + filterArray.join("&");
		}

		return this_.$http.get(`${this.entityName}/GetByPurchaseRequisition/${id}` + params, {
			// headers: {
			// 	'Authorization': `Bearer ${accessToken}`
			// },
			dataTransformer: (response) => {
				// if (this.entity != undefined && this.entity != null) {
				//     this_.$store.dispatch('entities/create', { entity: this.entity + 'list', data:  response.data  })
				// }
				return response.data.data;
			}
		})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
				return false;
			});
	}
}